import React from 'react';

interface IcoStarHalfProps {
    size?: number;
}

export const IcoStarHalf: React.FC<IcoStarHalfProps> = ({ size = 16 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
                <g fill="none" opacity=".6">
                    <path
                        fill="#B8B8B8"
                        d="M7.085 1.51 5.348 4.78a.279.279 0 0 1-.2.144l-3.65.64A1.036 1.036 0 0 0 .931 7.3l2.578 2.66a.285.285 0 0 1 .077.235l-.52 3.664a1.035 1.035 0 0 0 1.48 1.075l3.33-1.627A.28.28 0 0 1 8 13.28V.960c-.384 0-.736.212-.916.55z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="m12.49 9.96 2.578-2.66a1.034 1.034 0 0 0-.565-1.737l-3.651-.639a.279.279 0 0 1-.2-.145L8.915 1.51A1.038 1.038 0 0 0 8 .96v12.32a.29.29 0 0 1 .124.028l3.33 1.626a1.034 1.034 0 0 0 1.48-1.074l-.52-3.665a.28.28 0 0 1 .076-.235z"
                    />
                </g>
            </svg>
        </div>
    );
};
